module.exports = {"230503001":"中山街道","230503002":"北山街道","230503003":"南山街道","230503004":"东山街道","230503005":"中心街道","230503006":"西山街道","230503200":"长胜乡","230503400":"岭东区青山旅游公司","230503401":"岭东区岭东经营所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230503.json
// module id = 724
// module chunks = 0